<style scoped>
  .message-wrap {
    font-family: PingFangSC-Regular;
    font-size: 0.22rem;
    color: rgb(255, 255, 255);
    text-align: center;
    padding: 0.08rem 0.24rem;
    line-height: 0.32rem;
    background: rgba(56, 56, 56, 0.9);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 0.30rem;
    transform: translateX(-50%) translateY(-50%);
    z-index: 10;
  }
</style>
<template>
  <span class="message-wrap" @click="cb" v-if="isShow">
    {{ message }}
  </span>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      timer: null,
      message: ''
    }
  },
  watch: {
    isShow(val) {
      if(val) {
        this.setTimer()
      }
    }
  },
  methods: {
    setTimer() {
      this.timer = setTimeout(() => {
        this.isShow = false
        clearTimeout(this.timer)
      }, 3000)
    }
  },
  beforeDestroy() {
  }
}
</script>


